export default "__VITE_ASSET__lkJefq4n__"